import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VAlert,{staticClass:"white--text",attrs:{"dense":"","type":"warning"}},[_vm._v(" The call will be ended once the kiosk user ends the call and you will be redirected to homepage. ")])],1),_c(VCol,{staticClass:"mt-5",attrs:{"cols":"12","align":"center","justify":"center"}},[_c('div',{staticClass:"video-panel",attrs:{"id":"video-panel"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }